declare const GridVariants: readonly [
  '1/3,2/3',
  '1/4,3/4',
  '1/6,2/3,1/6',
  '1/2,1/4,1/4',
  '2/3,1/3',
  '3/4,1/4',
  '7/12,5/12',
  'collage-1',
  'collage-2',
  'even-2',
  'even-3',
  'even-4',
  'even-5',
  'even-6'
];
declare type GridVariantsType = typeof GridVariants[number];
export const getGridVariantType = (number: number) => {
  switch (number) {
    case 2:
    case 3:
    case 4:
    case 5:
    case 6:
      return `even-${number}` as GridVariantsType;
    default:
      return `even-3` as GridVariantsType;
  }
};
